import { authTokenName } from "../../entities/authTokenName"
import { initialProjectDirectory } from "../../entities/initialProjectDirectory"

export const logOut = (navigate)=>{
    sessionStorage.removeItem(authTokenName)
    navigate(`${initialProjectDirectory}/logIn`)
}